/*
 * ─────────────────────────────────────────────────────────────────────────────
 * VECCHI FILE GESTIONE CORSI — sostituiti dalla gestione in
 * src/jsx/pages/struttura/corsi/. Non sono più raggiungibili dal menu: restano
 * solo per gli indirizzi diretti, finché non si decide di eliminarli.
 * ─────────────────────────────────────────────────────────────────────────────
 */
import React, { useState, useEffect } from "react";
import { Row, Col, Card, Modal, Button, Spinner, Tab, Nav, Table, Form, Dropdown } from "react-bootstrap";
import { Link, useNavigate, useParams } from 'react-router-dom';
import { More, Trash, Eye } from 'iconsax-react';
import MyApiClient from "../../../../../api-client/MyApiClient";
import DEFAULT_USER from "../../../../../images/DEFAULT_USER.png";
import TabellaLista from "../../../../components/Tabella/TabellaLista";
import { ColumnFilter } from "../../../../components/table/FilteringTable/ColumnFilter";
import { usePageTitle } from "../../../../layouts/PageHeaderExtra";
import { useStatoNelTitolo } from "../../../../components/Util/StatoProdotto";

// Stati della squadra nella tendina: Sospesa e Conclusa si vedono ma non si scelgono da qui
const STATI_SQUADRA_TENDINA = [
    { value: 'ACTIVE', label: 'Attiva', tono: 'attivo' },
    { value: 'INACTIVE', label: 'Non attiva', tono: 'non-attivo' },
    { value: 'SUSPENDED', label: 'Sospesa', tono: 'non-attivo', disabled: true },
    { value: 'COMPLETED', label: 'Conclusa', tono: 'neutro', disabled: true },
];

export const UserCoursesTeamsView = () => {

    const { id } = useParams();
    const navigate = useNavigate();

    const [loadingShowed, setLoadingShowed] = useState(false);
    const [modalShowed, setModalShowed] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalText, setModalText] = useState('');
    const [teamData, setTeamData] = useState(null);
    const [members, setMembers] = useState([]);
    const [membersLoading, setMembersLoading] = useState(false);
    const [slotBookings, setSlotBookings] = useState([]);
    const [slotBookingsLoading, setSlotBookingsLoading] = useState(false);
    const [attendances, setAttendances] = useState([]);
    const [attendancesLoading, setAttendancesLoading] = useState(false);
    const [courseData, setCourseData] = useState(null);
    const [availableUsers, setAvailableUsers] = useState([]);
    const [addMemberModalShowed, setAddMemberModalShowed] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState('');
    const [addingMember, setAddingMember] = useState(false);
    const [attendanceFilter, setAttendanceFilter] = useState('');
    const [memberToDelete, setMemberToDelete] = useState(null);
    const [confirmDeleteMemberShowed, setConfirmDeleteMemberShowed] = useState(false);
    // Conferma dell'eliminazione della squadra (prima nel menu a fine riga della lista)
    const [confirmDeleteShowed, setConfirmDeleteShowed] = useState(false);

    // Titolo della pagina = il nome della squadra; finché non è caricata resta quello generico
    usePageTitle(teamData ? (teamData.name ?? teamData.teamName ?? '') : '');

    // Stato della squadra nella tendina accanto al titolo: si salva subito (regola SUI).
    // Una bozza mostra «Bozza» e si attiva dalla modifica della squadra.
    const cambiaStatoSquadra = async (nuovo) => {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (!tokenDetailsString) return { annullato: true };
        const token = JSON.parse(tokenDetailsString).idToken;
        const result = await new MyApiClient().updateCourseTeam(token, id, { status: nuovo });
        if (result && result.error) return { error: result.error };
        setTeamData(prev => ({ ...prev, status: nuovo }));
        return {};
    };
    useStatoNelTitolo({
        visibile: !!teamData?.status,
        bozza: teamData?.status === 'DRAFT',
        stati: STATI_SQUADRA_TENDINA,
        valore: teamData?.status,
        onCambia: cambiaStatoSquadra,
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

                    setLoadingShowed(true);
                    const courseTeams = await apiClient.getBookingCourseTeams(token);
                    setLoadingShowed(false);
                    
                    if (courseTeams && courseTeams.length > 0) {
                        // Trova il team specifico per ID
                        const team = courseTeams.find(team => team.id === id);
                        if (team) {
                            setTeamData(team);
                            // Fetch course data to check if it's OPEN
                            if (team.bookingCourseId) {
                                fetchCourseData(token, team.bookingCourseId);
                            }
                        } else {
                            setModalTitle("Errore");
                            setModalText("Team non trovato");
                            setModalShowed(true);
                        }
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                setLoadingShowed(false);
                setModalTitle("Errore");
                setModalText("Errore durante il caricamento dei dati");
                setModalShowed(true);
            }
        };

        fetchData();
    }, [id]);

    const fetchCourseData = async (token, courseId) => {
        try {
            const apiClient = new MyApiClient();
            const course = await apiClient.getBookingCourseById(token, courseId);
            setCourseData(course);
        } catch (error) {
            console.error('Error fetching course data:', error);
        }
    };

    const fetchAvailableUsers = async () => {
        if (!teamData?.bookingCourseId) return;
        
        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                const token = tokenDetails.idToken;
                const apiClient = new MyApiClient();
                
                const userCourses = await apiClient.getUserBookingCourses(token);

                // Filter users who PAID the same course and are not already in the team,
                // deduplicating by user (a user can have multiple purchase records for the same course)
                const currentMemberIds = members.map(member => member.userId);
                const seenUserIds = new Set();
                const eligibleUsers = userCourses.filter(userCourse => {
                    const userId = userCourse.juniorId || userCourse.playerId;
                    if (userCourse.course_id !== teamData.bookingCourseId) return false;
                    if (userCourse.status !== 'PAID') return false;
                    if (currentMemberIds.includes(userId)) return false;
                    if (seenUserIds.has(userId)) return false;
                    seenUserIds.add(userId);
                    return true;
                });

                setAvailableUsers(eligibleUsers);
            }
        } catch (error) {
            console.error('Error fetching available users:', error);
            setModalTitle("Errore");
            setModalText("Errore nel caricamento degli utenti disponibili");
            setModalShowed(true);
        }
    };

    const addMemberToTeam = async () => {
        if (!selectedUserId) {
            setModalTitle("Errore");
            setModalText("Seleziona un utente da aggiungere");
            setModalShowed(true);
            return;
        }
        
        setAddingMember(true);
        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                const token = tokenDetails.idToken;
                const apiClient = new MyApiClient();
                
                await apiClient.addMemberToTeam(token, id, { userId: selectedUserId });
                
                setAddMemberModalShowed(false);
                setSelectedUserId('');
                
                // Refresh members list
                fetchMembers();
                
                setModalTitle("Successo");
                setModalText("Membro aggiunto con successo alla squadra");
                setModalShowed(true);
            }
        } catch (error) {
            console.error('Error adding member to team:', error);
            setModalTitle("Errore");
            setModalText("Errore nell'aggiunta del membro alla squadra");
            setModalShowed(true);
        } finally {
            setAddingMember(false);
        }
    };

    const handleAddMemberClick = () => {
        fetchAvailableUsers();
        setAddMemberModalShowed(true);
    };

    const canAddMembers = () => {
        return courseData?.type === 'OPEN' && 
               members.length < teamData?.maxMembers;
    };

    const fetchMembers = async () => {
        setMembersLoading(true);
        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                const token = tokenDetails.idToken;
                const apiClient = new MyApiClient();
                const response = await apiClient.getBookingCourseTeamMembers(token, id);
                setMembers(response || []);
            }
        } catch (error) {
            console.error('Error fetching members:', error);
            setModalTitle("Errore");
            setModalText("Errore nel caricamento dei membri");
            setModalShowed(true);
        } finally {
            setMembersLoading(false);
        }
    };

    const fetchSlotBookings = async () => {
        if (!id) return;
        
        setSlotBookingsLoading(true);
        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                const token = tokenDetails.idToken;
                const apiClient = new MyApiClient();
                
                const slotBookingsData = await apiClient.getTeamSlotBookings(token, id);
                setSlotBookings(slotBookingsData || []);
            }
        } catch (error) {
            console.error('Error fetching slot bookings:', error);
            setModalTitle("Errore");
            setModalText("Errore nel caricamento della pianificazione");
            setModalShowed(true);
        } finally {
            setSlotBookingsLoading(false);
        }
    };

    const fetchAttendances = async () => {
        if (!id) return;
        
        setAttendancesLoading(true);
        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                const token = tokenDetails.idToken;
                const apiClient = new MyApiClient();
                
                const attendancesData = await apiClient.getTeamAttendances(token, id);
                setAttendances(attendancesData || []);
            }
        } catch (error) {
            console.error('Error fetching attendances:', error);
            setModalTitle("Errore");
            setModalText("Errore nel caricamento delle presenze");
            setModalShowed(true);
        } finally {
            setAttendancesLoading(false);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('it-IT');
    };

    const formatDateTime = (timestamp) => {
        if (!timestamp) return '';
        const date = new Date(timestamp);
        return date.toLocaleString('it-IT', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const getDayOfWeek = (timestamp) => {
        if (!timestamp) return '';
        const date = new Date(timestamp);
        const days = ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'];
        return days[date.getDay()];
    };

    const getStatusBadge = (status) => {
        const badgeClass = status === 'PRESENT' ? 'badge-success' : 
                          status === 'ABSENT' ? 'badge-danger' : 
                          'badge-secondary';
        const statusText = status === 'PRESENT' ? 'Presente' : 
                          status === 'ABSENT' ? 'Assente' : 
                          status;
        return <span className={`badge ${badgeClass}`}>{statusText}</span>;
    };

    const getUserTypeBadge = (userType) => {
        const badgeClass = userType === 'JUNIOR' ? 'badge-info' :
                          (userType === 'IDS_PLAY' || userType === 'PLAYER' || userType === 'IDS_GURU') ? 'badge-primary' :
                          'badge-secondary';
        const typeText = userType === 'JUNIOR' ? 'Junior' :
                        (userType === 'IDS_PLAY' || userType === 'PLAYER' || userType === 'IDS_GURU') ? 'Player' :
                        userType;
        return <span className={`badge ${badgeClass}`}>{typeText}</span>;
    };

    const formatWeeklySchedule = (schedule) => {
        if (!schedule || schedule.length === 0) return 'Nessuna pianificazione';
        return schedule.map(item => `${item.day}: ${item.startTime} - ${item.endTime}`).join('\n');
    };

    const goBack = () => {
        navigate('/struttura/booking/userCoursesTeams');
    };

    const handleChange = (e) => {
        setTeamData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSaveAll = async () => {
        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (!tokenDetailsString) return;
            const tokenDetails = JSON.parse(tokenDetailsString);
            const token = tokenDetails.idToken;
            const apiClient = new MyApiClient();
            setLoadingShowed(true);
            const payload = {
                name: (teamData.name ?? teamData.teamName ?? '').toString(),
                description: teamData.description ?? '',
                maxMembers: parseInt(teamData.maxMembers, 10) || 0,
            };
            const result = await apiClient.updateCourseTeam(token, id, payload);
            setLoadingShowed(false);
            if (result && result.error) {
                setModalTitle("Errore durante l'aggiornamento");
                setModalText(result.error);
                setModalShowed(true);
            } else {
                navigate('/struttura/booking/userCoursesTeams');
            }
        } catch (error) {
            setLoadingShowed(false);
            setModalTitle("Errore durante l'aggiornamento");
            setModalText("Errore durante l'aggiornamento della squadra.");
            setModalShowed(true);
        }
    };

    const renderEditableField = (fieldName, label, type = 'text') => {
        const value = teamData[fieldName];
        return (
            <div>
                <Form.Label className="mb-2">{label}</Form.Label>
                {type === 'textarea' ? (
                    <Form.Control as="textarea" rows={4} className="mt-2" name={fieldName} value={value || ''} onChange={handleChange} />
                ) : (
                    <Form.Control type={type} className="mt-2" name={fieldName} value={(value || value === 0) ? value : ''} onChange={handleChange} />
                )}
            </div>
        );
    };

    // Eliminazione della squadra: spostata qui dalla lista (booking/userCoursesTeams/index.js)
    const confirmDelete = async () => {
        setConfirmDeleteShowed(false);
        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                const token = tokenDetails.idToken;
                const apiClient = new MyApiClient();
                setLoadingShowed(true);
                const result = await apiClient.deleteCourseTeam(token, id);
                setLoadingShowed(false);
                if (result === true) {
                    goBack();
                } else {
                    setModalTitle("Errore");
                    setModalText(result?.error || "Errore durante l'eliminazione");
                    setModalShowed(true);
                }
            }
        } catch (error) {
            setLoadingShowed(false);
            setModalTitle("Errore");
            setModalText("Errore durante l'eliminazione");
            setModalShowed(true);
        }
    };

    const askDeleteMember = (member) => {
        setMemberToDelete(member);
        setConfirmDeleteMemberShowed(true);
    };

    const confirmRemoveMember = async () => {
        if (!memberToDelete) return;
        setConfirmDeleteMemberShowed(false);
        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                const token = tokenDetails.idToken;
                const apiClient = new MyApiClient();
                setLoadingShowed(true);
                const result = await apiClient.removeMemberFromTeam(token, id, memberToDelete.userId);
                setLoadingShowed(false);
                if (result === true) {
                    setMembers(prev => prev.filter(m => m.userId !== memberToDelete.userId));
                } else {
                    setModalTitle("Errore");
                    setModalText(result?.error || "Errore durante la rimozione");
                    setModalShowed(true);
                }
            }
        } catch (error) {
            setLoadingShowed(false);
            setModalTitle("Errore");
            setModalText("Errore durante la rimozione del membro");
            setModalShowed(true);
        } finally {
            setMemberToDelete(null);
        }
    };

    if (!teamData) {
        return (
            <>
                <Modal className="fade" show={loadingShowed} centered>
                    <Modal.Body className="text-center">
                        <Spinner animation="border" role="status">
                            <span className="sr-only">Loading...</span>
                        </Spinner>
                        <div>Caricamento in corso...</div>
                    </Modal.Body>
                </Modal>

                <Modal className="fade" show={modalShowed} centered>
                    <Modal.Header>
                        <Modal.Title>{modalTitle}</Modal.Title>
                        <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
                        </Button>
                    </Modal.Header>
                    <Modal.Body>
                        <Row><Col className="col-xl-64">{modalText}</Col></Row>
                    </Modal.Body>
                    <Modal.Footer className="justify-content-between">
                        <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
                            Chiudi
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }

    const membersColumns = [
        {
            Header: 'Membro',
            Footer: 'Membro',
            id: 'member',
            accessor: row => `${row.firstName || ''} ${row.lastName || ''}`,
            Filter: ColumnFilter,
            Cell: ({ row }) => {
                const member = row.original;
                return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img
                            src={member.profilePicture ? member.profilePicture : DEFAULT_USER}
                            alt={`${member.firstName} ${member.lastName}`}
                            style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                marginRight: '10px',
                                objectFit: 'cover'
                            }}
                        />
                        <div>
                            <span>{member.firstName} {member.lastName}</span>
                            <div className="mt-1">
                                {getUserTypeBadge(member.userType)}
                            </div>
                        </div>
                    </div>
                );
            }
        },
        {
            Header: 'Azione',
            Footer: 'Azione',
            accessor: 'azione',
            disableFilters: true,
            Cell: ({ row }) => (
                <Dropdown drop="auto">
                    <Dropdown.Toggle className="btn-primary light sharp i-false btn-action">
                        <More />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item
                            as={Link}
                            to={row.original.userType === 'JUNIOR'
                                ? `/struttura/junior/junior_profile/${row.original.userId}`
                                : `/struttura/clienti/player_profile/${row.original.userId}`}
                        >
                            <span className="me-2"><Eye size="20" /></span>Visualizza
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => askDeleteMember(row.original)} className="text-danger">
                            <span className="me-2"><Trash size="20" /></span>Rimuovi dalla squadra
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            )
        }
    ];

    const tabData = [
        {
            id: "informazioni",
            name: "Informazioni generali",
            content: (
                <Card>
                    <Card.Header><h4 className="card-title">Informazioni generali Squadra</h4></Card.Header>
                    <Card.Body>
                        <Row>
                            <Col className="col-xl-6">
                                <div className="mb-3">
                                    {renderEditableField('name', 'Nome Squadra', 'text')}
                                </div>
                            </Col>
                            <Col className="col-xl-6">
                                <div className="mb-3">
                                    <Form.Label>Corso associato</Form.Label>
                                    <Form.Control disabled className="mt-2" style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: '15px', fontWeight: 'normal', fontSize: '14px'}} type="text" value={courseData?.name || ''} />
                                </div>
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col className="col-xl-6">
                                <div className="mb-3">
                                    <Form.Label>Staff tecnico</Form.Label>
                                    <Form.Control disabled className="mt-2" style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: '15px', fontWeight: 'normal', fontSize: '14px'}} type="text" value={teamData.coach?.firstName ? `${teamData.coach.firstName} ${teamData.coach.lastName}` : (teamData.coachName || '')} />
                                </div>
                            </Col>
                            <Col className="col-xl-6">
                                <div className="mb-3">
                                    <Form.Label>Impianto</Form.Label>
                                    <Form.Control disabled className="mt-2" style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: '15px', fontWeight: 'normal', fontSize: '14px'}} type="text" value={teamData.venueName || 'Non specificato'} />
                                </div>
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col className="col-xl-6">
                                <div className="mb-3">
                                    <Form.Label>Numero Membri</Form.Label>
                                    <Form.Control disabled className="mt-2" style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: '15px', fontWeight: 'normal', fontSize: '14px'}} type="text" value={`${teamData.membersIds.length} / ${teamData.maxMembers}`} />
                                </div>
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col className="col-xl-6">
                                <div className="mb-3">
                                    {renderEditableField('description', 'Descrizione', 'textarea')}
                                </div>
                            </Col>
                            <Col className="col-xl-6">
                                <div className="mb-3">
                                    {renderEditableField('maxMembers', 'Max Membri', 'number')}
                                </div>
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col className="col-xl-6">
                                <div className="mb-3">
                                    <Form.Label>Data Inizio</Form.Label>
                                    <Form.Control disabled className="mt-2" style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: '15px', fontWeight: 'normal', fontSize: '14px'}} type="text" value={formatDate(teamData.startDate) || ''} />
                                </div>
                            </Col>
                            <Col className="col-xl-6">
                                <div className="mb-3">
                                    <Form.Label>Data Fine</Form.Label>
                                    <Form.Control disabled className="mt-2" style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: '15px', fontWeight: 'normal', fontSize: '14px'}} type="text" value={formatDate(teamData.endDate) || ''} />
                                </div>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            )
        },
        {
            id: "membri",
            name: "Membri",
            content: (
                <TabellaLista
                    cardTitle={'Componenti della squadra'}
                    hasSearch={true}
                    hasFilter={false}
                    data_column={membersColumns}
                    data_json={membersLoading ? null : members}
                    openColumn={'member'}
                    openRow={(row) => navigate(row.userType === 'JUNIOR'
                        ? `/struttura/junior/junior_profile/${row.userId}`
                        : `/struttura/clienti/player_profile/${row.userId}`)}
                    hasAddMoreAsModal={canAddMembers()}
                    modalCallBack={handleAddMemberClick}
                    labelAddMore={'Aggiungi membro'}
                    sort_by={'member'}
                    sort_type={'asc'}
                />
            )
        },
        {
            id: "pianificazione",
            name: "Pianificazione",
            content: (
                <Card>
                    <Card.Header><h4 className="card-title">Pianificazione attività della squadra</h4></Card.Header>
                    <Card.Body>
                        {slotBookingsLoading ? (
                            <div className="text-center">
                                <Spinner animation="border" role="status">
                                    <span className="sr-only">Loading...</span>
                                </Spinner>
                                <div>Caricamento slot bookings...</div>
                            </div>
                        ) : (
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>Giorno</th>
                                        <th>Data Inizio</th>
                                        <th>Data Fine</th>
                                        <th>Stato</th>
                                        <th>Corso</th>
                                        <th>Staff tecnico</th>
                                        <th>Impianto</th>
                                        <th>Note</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {slotBookings.length === 0 ? (
                                        <tr>
                                            <td colSpan="8" className="text-center">Nessuna seduta a calendario.</td>
                                        </tr>
                                    ) : (
                                        slotBookings.map((booking, index) => (
                                            <tr key={booking.id || index}>
                                                <td><strong>{getDayOfWeek(booking.startDateTime)}</strong></td>
                                                <td>{formatDateTime(booking.startDateTime)}</td>
                                                <td>{formatDateTime(booking.endDateTime)}</td>
                                                <td>
                                                    <span className={`badge ${
                                                        booking.status === 'CONFIRMED' ? 'badge-success' :
                                                        booking.status === 'PENDING' ? 'badge-warning' :
                                                        booking.status === 'CANCELLED' ? 'badge-danger' :
                                                        'badge-secondary'
                                                    }`}>
                                                        {booking.status === 'CONFIRMED' ? 'Confermato' :
                                                         booking.status === 'PENDING' ? 'In attesa' :
                                                         booking.status === 'CANCELLED' ? 'Annullato' :
                                                         booking.status}
                                                    </span>
                                                </td>
                                                <td>{booking.courseName || 'N/A'}</td>
                                                <td>{booking.coachName || 'N/A'}</td>
                                                <td>{booking.venueName || 'N/A'}</td>
                                                <td>{booking.notes || 'N/A'}</td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </Table>
                        )}
                    </Card.Body>
                </Card>
            )
        },
        {
            id: "presenze",
            name: "Presenze",
            content: (
                <Card>
                    <Card.Header>
                        <div className="d-flex justify-content-between align-items-center w-100">
                            <h4 className="card-title mb-0">Presenze della squadra</h4>
                            <div className="ms-auto">
                                <Form.Control
                                    type="text"
                                    placeholder="Filtra per membro..."
                                    value={attendanceFilter}
                                    onChange={e => setAttendanceFilter(e.target.value)}
                                    style={{ maxWidth: 240 }}
                                    size="sm"
                                />
                            </div>
                        </div>
                    </Card.Header>
                    <Card.Body>
                        {attendancesLoading ? (
                            <div className="text-center">
                                <Spinner animation="border" role="status">
                                    <span className="sr-only">Loading...</span>
                                </Spinner>
                                <div>Caricamento presenze...</div>
                            </div>
                        ) : (
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>Giorno</th>
                                        <th>Data Inizio</th>
                                        <th>Data Fine</th>
                                        <th>Player</th>
                                        <th>Staff tecnico</th>
                                        <th>Stato</th>
                                        <th>Inserimento</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {attendances.length === 0 ? (
                                        <tr>
                                            <td colSpan="7" className="text-center">Nessuna presenza trovata</td>
                                        </tr>
                                    ) : (
                                        attendances.filter(a => !attendanceFilter || (a.playerName || '').toLowerCase().includes(attendanceFilter.toLowerCase())).map((attendance, index) => (
                                            <tr key={attendance.id || index}>
                                                <td><strong>{getDayOfWeek(attendance.activityStartDateTime || attendance.startDateTime)}</strong></td>
                                                <td>{formatDateTime(attendance.activityStartDateTime || attendance.startDateTime)}</td>
                                                <td>{formatDateTime(attendance.activityEndDateTime || attendance.endDateTime)}</td>
                                                <td>
                                                    <div>
                                                        {attendance.playerName}
                                                        <div className="mt-1">
                                                            {getUserTypeBadge(attendance.userType)}
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>{attendance.coachName || 'N/A'}</td>
                                                <td>{getStatusBadge(attendance.status)}</td>
                                                <td>{formatDateTime(attendance.createdAt)}</td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </Table>
                        )}
                    </Card.Body>
                </Card>
            )
        }
    ];

    return (
        <>
            <Modal className="fade" show={modalShowed} centered>
                <Modal.Header>
                    <Modal.Title>{modalTitle}</Modal.Title>
                    <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{modalText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
                        Chiudi
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal className="fade" show={loadingShowed} centered>
                <Modal.Body className="text-center">
                    <Spinner animation="border" role="status">
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                    <div>Caricamento in corso...</div>
                </Modal.Body>
            </Modal>

            <Row className="align-items-start mt-4">
                <div className="col-xl-12">

                    <div className="custom-tab-1">
                        <Tab.Container defaultActiveKey="informazioni">
                            <Nav as="ul" className="nav-tabs" style={{ border: 'none' }}>
                                {tabData.map((data, i) => (
                                    <Nav.Item as="li" key={i} className="tabMenu">
                                        <Nav.Link 
                                            eventKey={data.id.toLowerCase()}
                                            onClick={data.id === 'membri' ? fetchMembers : data.id === 'pianificazione' ? fetchSlotBookings : data.id === 'presenze' ? fetchAttendances : undefined}
                                        >
                                            {data.name}
                                        </Nav.Link>
                                    </Nav.Item>
                                ))}
                            </Nav>
                            <Row className="align-items-start mt-4">
                                <div className="col-12">
                                    <Tab.Content>
                                        {tabData.map((data, i) => (
                                            <Tab.Pane eventKey={data.id.toLowerCase()} key={i}>
                                                {data.content}
                                            </Tab.Pane>
                                        ))}
                                    </Tab.Content>
                                    <div className="d-flex justify-content-between mt-4">
                                        <button type="button" className="btn btn-danger light" onClick={() => setConfirmDeleteShowed(true)}>Elimina</button>
                                        <div className="d-flex gap-4">
                                            <button type="button" className="btn btn-dark light" onClick={() => goBack(0)}>Indietro</button>
                                            <Button onClick={handleSaveAll} className="btn btn-primary">Salva</Button>
                                        </div>
                                    </div>
                                </div>
                            </Row>
                        </Tab.Container>
                    </div>
                </div>
            </Row>

            <Modal className="fade" show={confirmDeleteMemberShowed} centered>
                <Modal.Header>
                    <Modal.Title>Conferma rimozione</Modal.Title>
                    <Button onClick={() => setConfirmDeleteMemberShowed(false)} variant="" className="btn-close"></Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col>Sei sicuro di voler rimuovere <strong>{memberToDelete?.firstName} {memberToDelete?.lastName}</strong> dalla squadra?</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-light btn-add" onClick={() => setConfirmDeleteMemberShowed(false)}>Annulla</Button>
                    <Button className="btn btn-danger btn-add" onClick={confirmRemoveMember}>Rimuovi</Button>
                </Modal.Footer>
            </Modal>

            <Modal className="fade" show={confirmDeleteShowed} centered>
                <Modal.Header>
                    <Modal.Title>Conferma eliminazione</Modal.Title>
                    <Button onClick={() => setConfirmDeleteShowed(false)} variant="" className="btn-close"></Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col>Sei sicuro di voler eliminare la squadra <strong>{teamData.name ?? teamData.teamName}</strong>? L'operazione non è reversibile.</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-light btn-add" onClick={() => setConfirmDeleteShowed(false)}>Annulla</Button>
                    <Button className="btn btn-danger btn-add" onClick={confirmDelete}>Elimina</Button>
                </Modal.Footer>
            </Modal>

            {/* Add Member Modal */}
            <Modal show={addMemberModalShowed} onHide={() => setAddMemberModalShowed(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Aggiungi Membro alla squadra</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {availableUsers.length === 0 ? (
                        <p>Nessun utente disponibile per questo corso.</p>
                    ) : (
                        <>
                            <p>Seleziona un utente da aggiungere alla squadra:</p>
                            <Form.Select 
                                value={selectedUserId} 
                                onChange={(e) => setSelectedUserId(e.target.value)}
                                className="mb-3"
                            >
                                <option value="">Seleziona un utente...</option>
                                {availableUsers.map((userCourse) => {
                                    const userId = userCourse.juniorId || userCourse.playerId;
                                    const displayName = userCourse.juniorId 
                                        ? `${userCourse.juniorName} (Junior)`
                                        : userCourse.playerName;
                                    
                                    return (
                                        <option key={userId} value={userId}>
                                            {displayName || 'Nome non disponibile'}
                                        </option>
                                    );
                                })}
                            </Form.Select>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button 
                        variant="secondary" 
                        onClick={() => setAddMemberModalShowed(false)}
                        disabled={addingMember}
                    >
                        Annulla
                    </Button>
                    <Button 
                        variant="primary" 
                        onClick={addMemberToTeam}
                        disabled={!selectedUserId || addingMember || availableUsers.length === 0}
                    >
                        {addingMember ? (
                            <>
                                <Spinner size="sm" className="me-2" />
                                Aggiungendo...
                            </>
                        ) : (
                            'Aggiungi Membro'
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default UserCoursesTeamsView;